export default __webpack_public_path__ + "static/media/babylon5-quiz.64ba418f.jpg";